import React from 'react';

import { AnomalySectionProps } from './index';
import { EventTimelineSection } from './eventTimelineSection';

// The reboot event marker cannot be disabled (see DeviceEventsTimelineChart's lockedEvents prop),
// so it is both the only initially-enabled event here and the one locked event.
const INITIALLY_ENABLED_EVENTS = ['deviceRebooted'] as const;
const LOCKED_EVENTS = ['deviceRebooted'] as const;

export function RebootsSection(props: AnomalySectionProps) {
  return (
    <EventTimelineSection
      {...props}
      initiallyEnabledEvents={INITIALLY_ENABLED_EVENTS}
      lockedEvents={LOCKED_EVENTS}
      cypressId="deviceAnomalyExaminationRebootsTimeline"
    />
  );
}
